import React from 'react';

function Learn() {
    return (
        <div className="container text-center">
            <h1>Learn</h1>
        </div>
    )
}

export default Learn;
